<template>
  <div>
    <validation-observer
      v-slot="{handleSubmit}"
      ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(formSubmit)">
          <div class="form-row">
            <div class="col-sm-12">
              <base-input
                :label="$t('Text answer')"
                :name="$t('Text answer')"
              >
              <textarea
                v-model="answer"
                maxlength="1000"
                minlength="10"
                class="form-control"
                rows="3">
              </textarea>
              </base-input>
            </div>
          </div>
        <base-button
          type="primary"
          :disabled="disabled"
          native-type="submit">
          {{ $t('Send answer') }}
        </base-button>
      </form>
    </validation-observer>
  </div>
</template>


<script>
  export default {
    name: "FormTaskAnswerText",
    data() {
      return {
        answer: "",
        disabled: false
      }
    },
    methods: {
      formSubmit() {
        this.$emit('onAnswer', {"answer": this.answer});
        this.disabled = true;
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
